<label class="checkbox-status" matTooltipPosition="above" [matTooltip]="label">
  <span
    class="status-indicator"
    [ngClass]="{
      'checked': checked === true,
      'unchecked': checked === false,
      'not-applicable': checked === null,
      'disabled': disabled
    }"
  ></span>
  <input
    type="checkbox"
    [checked]="checked"
    [disabled]="disabled"
    (change)="onCheckboxChange($event)"
  />

</label>
